import { GetUserProfileFromCache } from "@/helper/cacheHelper";
import store from "../controller/baseController";
import Enums from "../enums/enums";
import userInfo from "../function/userInfo";
import {
  DoDeleteNotificationById,
  DoGetAllNotificationList,
  DoGetIsSeenNotificationList,
  DoGetUnSeenNotificationList,
  DoGetUnseenNotificationCount,
  DoSetNotificationIsSeenAll,
  DoSetNotificationIsSeenById,
  SocketDisconnect,
} from "../helper/notificationHelper";
import {
  GetTabById,
  GetTabIdFromSessionStorage,
  InsertTabIdToTabDB,
  IsMasterTab,
  UpdateTabMerchantId,
} from "../helper/tabHelper";
let userChannel = null;

export const SetUserChannel = (userId) => {
  if (userChannel) {
    userChannel.close();
  }
  userChannel = new BroadcastChannel(userId);

  userChannel.onmessage = async (event) => {
    if (event.data) {
      switch (event.data.broadcastType) {
        case Enums.BroadcastUserChannelType.AuthenticatedNotification:
          AuthenticatedNotificationFromBroadcast(event.data.request.authenticatedNotificationStatus);
          break;
        case Enums.BroadcastUserChannelType.DisconnectNotification:
          DisconnectNotificationFromBroadcast();
          break;
        case Enums.BroadcastUserChannelType.UpdateNotificationCount:
          UpdateNotificationCountFromBroadcast(event.data.request.merchantId);
          break;
        case Enums.BroadcastUserChannelType.UpdateAllNotificationList:
          UpdateAllNotificationListFromBroadcast(event.data.request.merchantId);
          break;
        case Enums.BroadcastUserChannelType.MasterDeleteNotificationById:
          MasterDeleteNotificationByIdFromBroadcast(
            event.data.request.merchantId,
            event.data.request.notificationId,
            event.data.request.isSeen
          );
          break;
        case Enums.BroadcastUserChannelType.MasterGetAllNotificationListByMerchantId:
          MasterGetAllNotificationListByMerchantIdFromBroadcast(event.data.request.merchantId);
          break;
        case Enums.BroadcastUserChannelType.MasterGetNotificationCountByMerchantId:
          MasterGetNotificationCountByMerchantIdFromBroadcast(event.data.request.merchantId);
          break;
        case Enums.BroadcastUserChannelType.DisconnectNotificationAllTab:
          DisconnectNotificationAllTabFromBroadcast();
          break;
        case Enums.BroadcastUserChannelType.ReCreateTab:
          ReCreateTabFromBroadcast();
          break;
        case Enums.BroadcastUserChannelType.MasterSetNotificationIsSeenAll:
          MasterSetNotificationIsSeenAllFromBroadcast(event.data.request.merchantId);
          break;
        case Enums.BroadcastUserChannelType.UpdateUnSeenNotificationList:
          UpdateUnSeenNotificationListFromBroadcast(event.data.request.merchantId);
          break;
        case Enums.BroadcastUserChannelType.UpdateIsSeenNotificationList:
          UpdateIsSeenNotificationListFromBroadcast(event.data.request.merchantId);
          break;
        case Enums.BroadcastUserChannelType.MasterGetUnSeenNotificationListByMerchantId:
          MasterGetUnSeenNotificationListByMerchantIdFromBroadcast(event.data.request.merchantId);
          break;
        case Enums.BroadcastUserChannelType.MasterGetIsSeenNotificationListByMerchantId:
          MasterGetIsSeenNotificationListByMerchantIdFromBroadcast(event.data.request.merchantId);
          break;
        case Enums.BroadcastUserChannelType.MasterSetNotificationIsSeenById:
          MasterSetNotificationIsSeenByIdFromBroadcast(
            event.data.request.merchantId,
            event.data.request.notificationId
          );
          break;

        case Enums.BroadcastUserChannelType.UpdateIsSeenNotificationFromActionIsSeen:
          UpdateIsSeenNotificationFromActionIsSeenFromBroadcast(event.data.request.merchantId);
          break;
        case Enums.BroadcastUserChannelType.CacheUpdateUserProfile:
          CacheUpdateUserProfileFromBroadcast();
          break;
        case Enums.BroadcastUserChannelType.CacheUpdateSelectedMerchant:
          CacheUpdateSelectedMerchantFromBroadcast();
          break;
      }
    }
  };
};

const AuthenticatedNotificationFromBroadcast = (authenticatedNotificationStatus) => {
  if (authenticatedNotificationStatus == Enums.AuthenticatedNotification.Success) {
    store.commit("MutationSetNotificationReadyToUse", true);
  } else {
    store.commit("MutationSetNotificationReadyToUse", false);
  }
};

const DisconnectNotificationFromBroadcast = () => {
  store.commit("MutationSetNotificationReadyToUse", false);
};

const UpdateNotificationCountFromBroadcast = async (merchantId) => {
  let tabId = GetTabIdFromSessionStorage();
  let tab = await GetTabById(tabId);

  if (tab && tab.merchantId == merchantId) {
    await store.commit("MutationSetNotificationCountFromIndexedDB");
  }
};

const UpdateAllNotificationListFromBroadcast = async (merchantId) => {
  let tabId = GetTabIdFromSessionStorage();
  let tab = await GetTabById(tabId);
  if (tab && tab.merchantId == merchantId) {
    await store.commit("MutationSetAllNotificationListFromIndexedDB");
  }
};

const UpdateUnSeenNotificationListFromBroadcast = async (merchantId) => {
  let tabId = GetTabIdFromSessionStorage();
  let tab = await GetTabById(tabId);
  if (tab && tab.merchantId == merchantId) {
    await store.commit("MutationSetUnSeenNotificationListFromIndexedDB");
  }
};

const UpdateIsSeenNotificationListFromBroadcast = async (merchantId) => {
  let tabId = GetTabIdFromSessionStorage();
  let tab = await GetTabById(tabId);
  if (tab && tab.merchantId == merchantId) {
    await store.commit("MutationSetIsSeenNotificationListFromIndexedDB");
  }
};

const UpdateIsSeenNotificationFromActionIsSeenFromBroadcast = async (merchantId) => {
  let tabId = GetTabIdFromSessionStorage();
  let tab = await GetTabById(tabId);
  if (tab && tab.merchantId == merchantId) {
    await store.commit("MutationSetNotificationFromActionIsSeen");
  }
};

const MasterDeleteNotificationByIdFromBroadcast = (merchantId, notificationId, isSeen) => {
  if (IsMasterTab()) {
    DoDeleteNotificationById(merchantId, notificationId, isSeen);
  }
};

const MasterGetAllNotificationListByMerchantIdFromBroadcast = (merchantId) => {
  if (IsMasterTab()) {
    DoGetAllNotificationList(merchantId);
  }
};

const MasterGetUnSeenNotificationListByMerchantIdFromBroadcast = (merchantId) => {
  if (IsMasterTab()) {
    DoGetUnSeenNotificationList(merchantId);
  }
};

const MasterGetIsSeenNotificationListByMerchantIdFromBroadcast = (merchantId) => {
  if (IsMasterTab()) {
    DoGetIsSeenNotificationList(merchantId);
  }
};

const MasterGetNotificationCountByMerchantIdFromBroadcast = (merchantId) => {
  if (IsMasterTab()) {
    DoGetUnseenNotificationCount(merchantId);
  }
};

const DisconnectNotificationAllTabFromBroadcast = () => {
  SocketDisconnect();
  store.commit("SOCKET_disconnect");
};

const ReCreateTabFromBroadcast = async () => {
  let merchantId = userInfo.MerchantId();
  await InsertTabIdToTabDB();
  await UpdateTabMerchantId(merchantId);
  BroadcastMasterGetNotificationCountByMerchantId(merchantId);
};

const MasterSetNotificationIsSeenAllFromBroadcast = async (merchantId) => {
  if (IsMasterTab()) {
    await DoSetNotificationIsSeenAll(merchantId);
  }
};

const MasterSetNotificationIsSeenByIdFromBroadcast = async (merchantId, notificationId) => {
  if (IsMasterTab()) {
    await DoSetNotificationIsSeenById(merchantId, notificationId);
  }
};

const CacheUpdateUserProfileFromBroadcast = async () => {
  GetUserProfileFromCache().then((userModel) => {
    if (userModel && userModel.userId > 0) {
      store.commit("loginSuccess", userModel);
    }
  });
};

const CacheUpdateSelectedMerchantFromBroadcast = async () => {
  const merchantId = userInfo.MerchantId();
  if (merchantId) {
    store.commit("MutationReSetMerchantModelList");

    const merchant = await store.dispatch("DoGetMerchantByResetCache", {
      merchantId: merchantId,
      isUseMainDatabase: true,
    });
    if (merchant) {
      store.commit("MutationSetSettingMerchantDetailLoadingStatus", Enums.LoadingStatusType.None);
      store.commit("MutationSetSettingMerchantAddressListLoadingStatus", Enums.LoadingStatusType.None);
      store.commit("MutationUpdateMerchantLockPeriodLoadingStatus", Enums.LoadingStatusType.None);
    }
  }
};

export const BroadcastInUserChannel = () => {
  if (userChannel) {
    userChannel.postMessage("Test");
  }
};

export const BroadcastUserMasterChannel = () => {
  if (userChannel) {
    userChannel.postMessage("toUserChannelMaster");
  }
};

export const BroadcastAuthenticatedNotificationStatus = (authenticatedNotificationStatus) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.AuthenticatedNotification,
      request: {
        authenticatedNotificationStatus: authenticatedNotificationStatus,
      },
    });
  }
};

export const BroadcastDisconnectNotification = () => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.DisconnectNotification,
      request: null,
    });
  }
};

export const BroadcastIsUpdateNotificationCount = (merchantId) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.UpdateNotificationCount,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastIsUpdateAllNotificationList = (merchantId) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.UpdateAllNotificationList,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastIsUpdateUnSeenNotificationList = (merchantId) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.UpdateUnSeenNotificationList,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastIsUpdateIsSeenNotificationList = (merchantId) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.UpdateIsSeenNotificationList,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastIsUpdateIsSeenNotificationFromActionIsSeen = (merchantId) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.UpdateIsSeenNotificationFromActionIsSeen,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastMasterDeleteNotificationById = (merchantId, notificationId, isSeen) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.MasterDeleteNotificationById,
      request: {
        merchantId: merchantId,
        notificationId: notificationId,
        isSeen: isSeen,
      },
    });
  }
};

export const BroadcastMasterGetAllNotificationListByMerchantId = (merchantId) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.MasterGetAllNotificationListByMerchantId,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastMasterGetUnSeenNotificationListByMerchantId = (merchantId) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.MasterGetUnSeenNotificationListByMerchantId,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastMasterGetIsSeenNotificationListByMerchantId = (merchantId) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.MasterGetIsSeenNotificationListByMerchantId,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastMasterGetNotificationCountByMerchantId = (merchantId) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.MasterGetNotificationCountByMerchantId,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastDisconnectNotificationAllTab = () => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.DisconnectNotificationAllTab,
      request: null,
    });
  }
};

export const BroadcastReCreateTab = () => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.ReCreateTab,
      request: null,
    });
  }
};

export const BroadcastCacheUpdateUserProfile = () => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.CacheUpdateUserProfile,
      request: null,
    });
  }
};
export const BroadcastCacheUpdateSelectedMerchant = () => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.CacheUpdateSelectedMerchant,
      request: null,
    });
  }
};
export const BroadcastMasterSetNotificationIsSeenAll = (merchantId) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.MasterSetNotificationIsSeenAll,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastMasterSetNotificationIsSeenById = (merchantId, notificationId) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.MasterSetNotificationIsSeenById,
      request: {
        merchantId: merchantId,
        notificationId: notificationId,
      },
    });
  }
};
